import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthorizationService, AssociationService } from './../../../../shared/index';
@Component({
    selector: 'live-tab',
    templateUrl: './live-tab.html',
    standalone: false
})
/** live-tab component*/
export class LiveTabComponent {
    public companyvisible = true;
    public minesitevisible = true;
    public equipmentvisible = true;

    private subscriptions: Subscription[] = [];

    constructor(
        private _authorizationService: AuthorizationService,
        private _associationService: AssociationService
    ) {
    }

    ngOnInit(): void {
        localStorage.removeItem('P_ID');
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
